import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CancelledEula from './cancelled-eula';
import AcceptableEula from './acceptable-eula';
import history from '../../history';

export const Eula = () => {
  const { isCancelled, eula } = useSelector(
    (state: CMx.ApplicationState) => state.eula
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (eula.eulaId === null) {
      history.push('/');
    }
  }, [dispatch, eula]);

  if (!isCancelled) {
    return <AcceptableEula />;
  } else {
    return <CancelledEula />;
  }
};
